// import logo from './logo.svg';
import React, { useRef, useEffect } from "react";
import ReactPlayer from 'react-player';


function GumletPlayer({src}) {
  const playerRef = useRef();
  const gumletConfig = {
    property_id: 'g3iOhbYo',
  };

  // The reference is used for a setInterval to wait for the player initliasation,
  const timer = useRef();
  const windowW = useRef()


  useEffect(()=>{
    windowW.current = document.getElementById('gumlet-player').parentElement.clientWidth;
  }, [])

  useEffect(() => {
    // loadGumletScript().then(() => {

    //   //Add a timer to load 
    //   timer.current = setInterval(async () => {
    //     if (playerRef.current.player.player && playerRef.current.player.player.hls) {

    //       gumletInsights = window.gumlet.insights(gumletConfig);
    //       gumletInsights.register(playerRef.current.player.player.hls);

    //       clearInterval(timer.current);
    //     }
    //   }, 100);
    // });
  }, [playerRef.current]);

  return (
    // <div className="App">
    //   <div>
    //     <ReactPlayer
    //       url='https://video.gumlet.io/68234c5275df8e27196c4511/68235796afe024e7bc502672/main.m3u8'
    //       autoPlay={true}
    //       controls={true}
    //       width="1200"
    //       height="auto"
    //       ref={playerRef}
    //     />
    //   </div>
    // </div>
    <div id='gumlet-player' style={
      {
        position: 'relative',
        aspectRatio: '16 / 9'
      }
    }>
      <iframe
        loading="lazy" title="Gumlet video player"
        src={`https://play.gumlet.io/embed/${src}?preload=false&autoplay=false&loop=false&background=false&disable_player_controls=false`}
        style={
          {
            border: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%'
          }
        }
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;">
      </iframe>
    </div>
  );
}
export default GumletPlayer;